<template>
  <div class="container mx-auto h-full h-screen flex justify-center items-center">
   <div
        v-if="tokenFailed"
        class="py-1 text-pink-dark border-2 p-2 mt-2 border-pink-dark bg-white"
      >
        <i>{{$t('all.token_failed')}}</i>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      tokenFailed: 'authentication/tokenFailed',
    }),
  },
  methods: {
    ...mapActions('authentication', ['checkToken']),
  },
  created() {
    this.checkToken(this.$route.query);
  },
};
</script>
